import { useLoginController } from "@Front/Components/Layouts/Login/hooks/useLoginController";
import { loginStepPanelFor } from "./LoginStepPanelBranches";

type Controller = ReturnType<typeof useLoginController>;

type Props = {
	controller: Controller;
};

export function LoginStepPanels(props: Props): React.JSX.Element {
	return <>{loginStepPanelFor(props.controller.step, props.controller)}</>;
}
